class AnnouncementHeadingRelocator extends HTMLElement {
  constructor() {
    super();
    this.updateHeadingPosition = this.updateHeadingPosition.bind(this);
  }

  connectedCallback() {
    this.heading = this.querySelector('[data-gdt-announcement-heading]');
    if (!this.heading) return;

    this.mobileMediaQuery = window.matchMedia('screen and (max-width: 767px)');
    this.mobileMediaQuery.addEventListener('change', this.updateHeadingPosition);
    document.addEventListener('shopify:section:load', this.updateHeadingPosition);
    this.updateHeadingPosition();
  }

  disconnectedCallback() {
    this.mobileMediaQuery?.removeEventListener('change', this.updateHeadingPosition);
    document.removeEventListener('shopify:section:load', this.updateHeadingPosition);

    this.mobileTarget?.classList.remove('is-active');
    this.classList.remove('is-relocated');
    this.mobileTarget = null;

    if (this.heading?.parentElement !== this) {
      this.append(this.heading);
    }
  }

  updateHeadingPosition() {
    if (!this.heading || !this.mobileMediaQuery) return;

    const mobileTarget = document.querySelector('[data-gdt-announcement-mobile-target]');
    const shouldRelocate = this.mobileMediaQuery.matches && mobileTarget;
    const destination = shouldRelocate ? mobileTarget : this;

    if (this.mobileTarget && this.mobileTarget !== mobileTarget) {
      this.mobileTarget.classList.remove('is-active');
    }

    if (this.heading.parentElement !== destination) {
      destination.append(this.heading);
    }

    this.classList.toggle('is-relocated', Boolean(shouldRelocate));

    if (shouldRelocate) {
      mobileTarget.classList.add('is-active');
      this.mobileTarget = mobileTarget;
    } else {
      this.mobileTarget?.classList.remove('is-active');
      this.mobileTarget = null;
    }
  }
}

if (!customElements.get('announcement-heading-relocator')) {
  customElements.define('announcement-heading-relocator', AnnouncementHeadingRelocator);
}
